module.exports = __webpack_public_path__ + "img/2.7230c6a5.svg";